import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('x-filler')
export class XFiller extends LitElement {
  static styles = css`
    :host {
      display: flex;
      flex: auto;
    }
  `;

  render() {
    return html`
      <slot></slot>
    `;
  }
}
